<script>
  import options from './DirectMessageNavigation.options'
  export default options
</script>

<template>

  <nav class="kb-direct-message-navigation" aria-label="søgning">
    <h2 id="directMessageNavigation" class="kb-direct-message-navigation__title">
      {{ getLabel("title") }}
    </h2>

    <div class="kb-general-search__input kb-direct-message-navigation__input">
      <input
        type="search"
        aria-labelledby="directMessageNavigation"
        :placeholder="getLabel('searchOverlayPlaceholder')"
        v-on:keyup="handleInputText"
        @keydown.enter="searchMessages"
        v-model="inputText"
        data-order="first"
      />
      <button
        @click="searchMessages"
        class="kb-general-search__input__button"
        title="Søg"
      >
        <svg viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9.5" stroke="#ffffff" />
          <path
            d="M16 10a6 6 0 0 0-6-6M24.768 25.89l-6.718-6.718 2.122-2.122 7.778 7.778-1.82 1.82"
            stroke="#ffffff"
          />
        </svg>
      </button>
    </div>
    <section class="kb-direct-message-navigation__scroll-wrapper">
  
      <h2 v-if="results && results.length > 0" id="directMessageNavigation" class="kb-direct-message-navigation__list-title">
        {{ getLabel("allResultsListTitle") }}
      </h2>
      <ul class="kb-direct-message-navigation__result-ul kb-direct-message-navigation__result-ul--search-results" aria-live="polite" v-if="results && results.length > 0">
          <li v-for="(result, index) in results" :key="index" class="kb-direct-message-navigation__result-li">
            <button class="kb-direct-message-navigation__result-li-button"
              :id="`message-${result.id}`"
              v-on:click="changeChat(result.id)">
               
                <figure class="kb-image-module kb-image-module--1-1 kb-direct-message-navigation__result-member-profile-img">
                  <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image">
                      <img :src="result.resultImgSrc" :alt="result.resultImgAlt" />
                    </picture>
                  </div>
                </figure>
          
                <div class="kb-direct-message-navigation__result-member-name">
                  <div class="kb-direct-message-navigation__result-member-name-group">
                    <p class="kb-direct-message-navigation__result-member-name-group-name">{{ result.chatName }}</p>
                    <span v-if="result.hasNotification" class="kb-direct-message-navigation__result-member-name-notification"></span>
                  </div>
                  <div class="kb-direct-message-navigation__result-text-wrapper">  
                    <p class="kb-direct-message-navigation__result-message" v-html="result.firstMessage"></p>
                  </div>
                </div>

              <p class="kb-direct-message-navigation__result-creation-date">
                {{ result.creationDate }}
              </p>  

            </button>
        </li>
      </ul>
    </section>

    <button v-if="getMoreMessageThreads" class="kb-button kb-button--spot-border-color"
      v-on:click="loadMoreMessageThreads">
      {{ getLabel("getMoreMessagesButtonLabel") }}
    </button>

    <button class="kb-button kb-button--full-color-spot kb-button--full-color-spot"
      v-on:click="startNewMessage">
      {{ getLabel("newMessageButtonText") }}      
    </button>
  </nav>
</template>
